import { AdConsole } from './Adconsole.js';
import { Facebook } from './Facebook.js';
import { Gitlab } from './Gitlab.js';
import { Google } from './Google.js';
import { Instagram } from './Instagram.js';
import { Linkedin } from './Linkedin.js';
import { Meta } from './Meta.js';
import { Microsoft } from './Microsoft.js';
import { Passendo } from './Passendo.js';
import { Semantiq } from './Semantiq.js';
import { X } from './X.js';
import { Xandr } from './Xandr.js';
import { Yaleo } from './Yaleo.js';
export const BrandIcons = {
    AdConsole,
    Facebook,
    Gitlab,
    Google,
    Instagram,
    Linkedin,
    Meta,
    Microsoft,
    Passendo,
    Semantiq,
    X,
    Xandr,
    Yaleo,
};
export default BrandIcons;
